var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFueltank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M2.892 0C1.832 0 .973.859.973 1.919v17.27a.96.96 0 1 0 0 1.919h13.432a.96.96 0 1 0 0-1.919v-3.838h2.879v2.399a3.373 3.373 0 0 0 3.358 3.358.96.96 0 0 0 .347-.071C22.663 20.853 24 19.47 24 17.75V9.595a.96.96 0 0 0-.281-.679L19.88 5.078a.96.96 0 0 0-.146-.12L16.857 3.04a.96.96 0 1 0-1.065 1.596l2.451 1.634v2.365c0 1.06.859 1.919 1.92 1.919h1.918v7.196c0 .807-.632 1.44-1.44 1.44-.806 0-1.438-.633-1.438-1.44V15.35c0-1.048-.87-1.919-1.92-1.919h-2.878V1.92C14.405.859 13.547 0 12.487 0H2.892zm0 1.919h9.595v5.757H2.892V1.919z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFueltank);
export default __webpack_public_path__ + "static/media/fueltank.3792dc693704a2ce6642408ee5e20fe0.svg";
export { ForwardRef as ReactComponent };